import { Box, Typography } from '@mui/material';

export function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        px: { xs: 2, md: 4 },
        py: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        textAlign: 'center',
      }}
    >
      <Typography variant="caption" color="text.secondary">
        © {new Date().getFullYear()} Abitare In S.p.A. — Home Configurator
      </Typography>
    </Box>
  );
}
